<section class="ag-switch-btn-container">
  @if (isOwnerRole) {
    <div>
      <span> Owner </span>
    </div>
  }

  @if (!isOwnerRole) {
    <section class="btn-toggle-container">
      <mat-button-toggle-group [formControl]="fontStyleControl" name="fontStyle" aria-label="Font Style">
        <mat-button-toggle
          id="Admin"
          value="Admin"
          (change)="onValChange($event.value)"
          class="btn-toggle"
          [ngClass]="{ 'btn-enabled': cellValue === 'Admin' }"
          >Admin</mat-button-toggle
        >

        <mat-button-toggle
          id="Contributor"
          value="Contributor"
          (change)="onValChange($event.value)"
          class="btn-toggle"
          [ngClass]="{ 'btn-enabled': cellValue === 'Contributor' }"
          >Contributor</mat-button-toggle
        >
      </mat-button-toggle-group>
    </section>
  }
</section>
